import { MenuItem, Select, SelectProps } from '@material-ui/core'
import { DateRangeOutlined } from '@material-ui/icons'

import { useStyles } from './styles'

interface Item {
  id: string
  date: string
  phenologicalStage: string
}

interface LayerSelectProps extends SelectProps {
  items?: Item[]
  renderDisabledItem?: Item
}

export const LayerSelect = ({
  items,
  renderDisabledItem,
  ...props
}: LayerSelectProps) => {
  const classes = useStyles()

  const renderDate = (date?: string) => {
    if (!date) return date

    const parsedDate = new Date(date)

    if (isNaN(parsedDate.getTime())) {
      return date
    }

    return parsedDate.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
    })
  }

  return (
    <div className={classes.root}>
      <Select
        className={classes.select}
        classes={{
          selectMenu: classes.selectMenu,
        }}
        MenuProps={{
          className: classes.menuList,
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        }}
        disableUnderline
        defaultValue={0}
        {...props}
      >
        <MenuItem disabled value={0} style={{ display: 'none' }}>
          <div className={classes.menuListItem}>
            <DateRangeOutlined />
            <span>{renderDate(renderDisabledItem?.date) || 'DD/MM/AAAA'}</span>
            <span>-</span>
            <span>{renderDisabledItem?.phenologicalStage || 'EF'}</span>
          </div>
        </MenuItem>

        {items?.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <div className={classes.menuListItem}>
              <DateRangeOutlined />
              <span>{renderDate(item.date)}</span>
              <span>-</span>
              <span>{item.phenologicalStage}</span>
            </div>
          </MenuItem>
        ))}
      </Select>
    </div>
  )
}
